import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { BnLoadingService, EntityPagedResult } from '@bndes/bndes-ux4/bndes-angular-utils';
import Utils from '../../../shared/fgi-utils';
import { ConsultaCadin } from './consulta-cadin.model';
import { ConsultaCadinService } from './consulta-cadin.service';

@Component({
  selector: 'app-consulta-cadin-pesquisar',
  templateUrl: './consulta-cadin-pesquisar.component.html',
  styleUrl: './consulta-cadin-pesquisar.component.scss',
  standalone: false
})
export class ConsultaCadinPesquisarComponent implements OnInit {

  pesquisaForm?: UntypedFormGroup;
  pesquisado?: boolean;
  esconderPesquisa: boolean = true;
  consultas?: ConsultaCadin[];
  cnpjSelecionado?: string;
  atualizadoEm?: string;

  // Opcoes do dropdown "Impedimentos"
  opcoesImpedimento = [
    { valor: 'TODOS', label: 'Todos' },
    { valor: 'COM', label: 'Com impedimento' },
    { valor: 'SEM', label: 'Sem impedimento' }
  ];

  atributosPaginacaoComponenteListagem?: EntityPagedResult<ConsultaCadin>;
  private opcoesPaginacao?: number[];
  private totalObjetosRetornados?: number;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loadingService: BnLoadingService,
    private service: ConsultaCadinService
  ) { }

  ngOnInit(): void {
    this.opcoesPaginacao = [10, 15, 20];
    this.atributosPaginacaoComponenteListagem = {
      page: 1, pageSize: this.opcoesPaginacao[0],
      pages: undefined, count: undefined, list: undefined
    };
    this.pesquisado = undefined;
    this.construirFormulario();
  }

  private construirFormulario() {
    this.pesquisaForm = this.formBuilder.group({
      cnpj: [''],
      impedimento: ['TODOS']
    });
  }

  mudancaPagina(novaPagina: EntityPagedResult<ConsultaCadin>) {
    this.atributosPaginacaoComponenteListagem = novaPagina;
    this.buscar(false, false);
  }

  limpar() {
    this.pesquisaForm.reset({ impedimento: 'TODOS' });
    this.pesquisado = undefined;
    this.consultas = undefined;
    this.atualizadoEm = undefined;
  }

  buscar(paginaVazia: boolean, voltarPagina1: boolean) {
    this.loadingService.bloqueiaTela();
    this.esconderPesquisa = true;

    const cnpj = this.pesquisaForm.get('cnpj')?.value;
    const impedimento = this.pesquisaForm.get('impedimento')?.value || 'TODOS';

    const params: any = { impedimento };
    if (cnpj) {
      params.cnpj = String(cnpj).replace(/\D/g, '');
    }

    if (voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = 1;
    }

    paginaVazia = Utils.verificaPaginaVazia(
      this.consultas, this.atributosPaginacaoComponenteListagem, this.totalObjetosRetornados);
    if (paginaVazia && !voltarPagina1) {
      this.atributosPaginacaoComponenteListagem.page = this.atributosPaginacaoComponenteListagem.pages;
    }
    params.pagina = this.atributosPaginacaoComponenteListagem.page;
    params.limite = this.atributosPaginacaoComponenteListagem.pageSize;

    this.service.consultar(params).subscribe(response => {
      this.consultas = response ? response.resultados : undefined;
      this.atributosPaginacaoComponenteListagem.count = response ? response.totalRegistrosSemPaginacao : 0;
      this.totalObjetosRetornados = this.atributosPaginacaoComponenteListagem.count;
      this.atualizarDataAtualizacao();
      this.pesquisado = true;
      this.esconderPesquisa = false;
      this.cnpjSelecionado = params.cnpj;
      this.loadingService.liberaTela();
    }, () => this.loadingService.liberaTela());
  }

  private atualizarDataAtualizacao() {
    if (!this.consultas || !this.consultas.length) {
      this.atualizadoEm = undefined;
      return;
    }
    const maior = this.consultas
      .map(c => c.dataConsulta)
      .filter(d => !!d)
      .sort()
      .pop();
    this.atualizadoEm = maior;
  }
}
